<template>
  <transition name="reveal-single-line">
    <div v-if="likes" class="single-obituary-comment__likes-count">
      <button :disabled="isLikeLoading" @click.prevent="switchLikingComment">
        <svg class="icon" :title="texts.liked">
          <use href="#heart-solid" />
        </svg>

        <span v-html="likes" />
      </button>
    </div>
  </transition>
</template>

<script>
import { toRef } from 'vue';
import { useLikeComment } from '../composables/useLikeComment';

export default {
  setup(props) {
    const commentRef = toRef(props, 'comment');
    const {
      isLikeLoading,
      likedComments,
      isCommentLiked,
      switchLikingComment,
    } = useLikeComment(commentRef);
    return {
      isLikeLoading,
      likedComments,
      isCommentLiked,
      switchLikingComment,
    };
  },

  props: {
    comment: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      texts: lavendlaObituary.common,
    };
  },

  computed: {
    likes() {
      return this.comment.likes || 0;
    },
  },
};
</script>
